import PairPositionSearchParamUI from "./PairPositionSearchParamUI";
import PairPositionTable from "../../../Tables/OptionDomain/PairPoisition/PairPositionTable";
import { Report } from "../../../Interfaces/TableInterfaces";
import useSearchParam from "../../../Hooks/useSearchParam";
import {
  IPairPositionSearchParams,
  ISelectedTableInfo,
} from "../../../Interfaces/optionDomain";
import { ReloadOutlined } from "@ant-design/icons";
import { useRef, useState } from "react";
import Orderbook from "./Orderbook";
import { IFilterTableCols } from "src/Tables/TableTemplate/tableTemplate";

interface IProps {
  filterCols: IFilterTableCols;
  refreshFlag: boolean;
  setRefreshFlag: (flag: boolean) => void;
}

const PairPositionWrapper = ({
  filterCols,
  refreshFlag,
  setRefreshFlag,
}: IProps) => {
  const {
    clientSearchParamChangeHandler,
    clientSearchParams,
    onSubmit,
    serverSearchParams,
  } = useSearchParam({ initialSearchParam: {} as IPairPositionSearchParams });
  const [selectedTableInfo, setSelectedTableInfo] =
    useState<ISelectedTableInfo>({} as ISelectedTableInfo);
  const prevRowRef = useRef<number | null>(null);

  return (
    <>
      <div className="flex flex-row justify-between items-end gap-1 w-full">
        <Orderbook selectedTableInfo={selectedTableInfo} />
        <div
          onClick={() => setRefreshFlag(true)}
          className="cursor-pointer mt-5"
        >
          <ReloadOutlined />
        </div>
      </div>
      <div className="flex flex-row justify-start items-start gap-1 w-full">
        <PairPositionSearchParamUI
          searchParam={clientSearchParams}
          searchParamChangeHandler={clientSearchParamChangeHandler}
          onSubmit={onSubmit}
        />
        <PairPositionTable
          filterCols={filterCols}
          refreshFlag={refreshFlag}
          searchParams={serverSearchParams}
          onRowClick={(row) => {
            if (prevRowRef.current === row.id) return;

            prevRowRef.current = row.id;
            setSelectedTableInfo({
              id: row.id,
              insIds: [
                {
                  insId: row.instrumentId1,
                  ratio: 1,
                  side: row.orderSideValue1,
                },
                {
                  insId: row.instrumentId2,
                  ratio: row.hedgeFactor?.toString().replaceAll(",", "") as any,
                  side: row.orderSideValue2,
                },
              ],
            });
          }}
          selectedTableRow={selectedTableInfo ? selectedTableInfo?.id : null}
        />
      </div>
    </>
  );
};

export default PairPositionWrapper;
